<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Student Information</legend>
            </div>
            <div class="row">
                <div class="small-12 medium-6 columns lp">
                    <labeled-input label="Student First Name" name="Student First Name" validation='max:20' v-model='sampleobject.firstName'></labeled-input>
                </div>
                <div class="small-12 medium-6 columns lp">
                    <labeled-input label="Student Last Name *" validation='required|max:20' name="Student Last Name" v-model='sampleobject.lastName'></labeled-input>
                </div>
            </div>
              <div class="row">
                <div class="medium-4 columns lp">
                    <div :class="{'error': errors.has('Telephone') }">
                        <label for="telephone">Telephone*</label>
                        <input id="telephone" @blur="formatShippingPhoneNumber()" type="text" v-validate="'required'" name="Telephone" class="full-txt" placeholder="" v-model='sampleobject.phone'>
                        <p class="error" v-if="errors.has('Telephone')">{{ errors.first('Telephone') }}</p>
                    </div>
                </div>
                <div class="medium-8 columns lp">
                    <labeled-input validation="required|email" label="Email *" name="Email" autocomplete="on" v-model='sampleobject.email'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <labeled-input label="Student ID *" name="Student ID" v-model='sampleobject.practiceName'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <div class="medium-6 columns lp">
                        <div :class="{'error': errors.has('Role') }">
                            <label for="year">Student Year of Graduation *</label>
                            <select v-validate data-vv-rules="required" v-model="sampleobject.role" name="Graduation year" id="year" class="orderinput-select">
                                <option selected value> </option>
                                <option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019">2019</option>
                                <option value="2020">2020</option>
                                <option value="2021">2021</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                                <option value="2026">2026</option>
                            </select>
                            <p class="error" v-if="errors.has('Role')">{{ errors.first('Role') }}</p>
                        </div>
                    </div>
                 
                </div>
                <div class="small-12 columns lp">
                    <labeled-input label="Current Lens Worn *" name="Current Lens Worn" v-model='sampleobject.currentLens'></labeled-input>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject"],
  inject: ["$validator"],
  components: { LabeledInput },
  methods: {
    formatShippingPhoneNumber() {
      this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
    },
    formatPhoneNumber(args) {
      var s2 = ("" + args).replace(/\D/g, "");
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
  },
  created() {
    this.formatShippingPhoneNumber();
  }
};
</script>
